import { CommunicationKey } from '@models/Communication'
import { AvailableLocale } from '@models/Lang'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TEST_COMMUNICATIONS_URL } from '@utils/urls'

const sendCommunicationTest = (
  key: CommunicationKey,
  testUsers: number[],
  lang: AvailableLocale,
  context?: Record<string, string | number>,
  content?: any
) =>
  SBAPI.Post(`${TEST_COMMUNICATIONS_URL}/send-test`, {
    key,
    testUsers,
    locale: lang,
    context,
    ...content,
  })

export { sendCommunicationTest }
